import { NotFound } from "@dgs/core";
import { FC } from "react";
import { Route, Routes } from "react-router";
import { IndustryList } from "../Industry/IndustryList";

export const IndustryPage: FC = () => {
	return (
		<Routes>
			<Route index element={<IndustryList />} />
			<Route path="*" element={<NotFound />} />
		</Routes>
	);
};
